import HeaderIndicatorsContainer from './HeaderIndicatorsContainer'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId
  }
}

export default connect(mapStateToProps)(HeaderIndicatorsContainer)



// WEBPACK FOOTER //
// ./src/modules/Indicators/Header/HeaderIndicatorsContainer/index.js